import {
  normalizarStatusConexao,
  normalizarWhatsAppItem,
  statusComandoFalhouResolver,
} from "./whatsappStatusUtils"

export function logCanalAusenteNoEstado(cAcao, nCanalId) {
  if (typeof console !== "undefined" && console.warn) {
    console.warn("[useWhatsApps] evento ignorado: canal ausente na lista", {
      acao: cAcao,
      canalId: nCanalId,
    })
  }
}

export const whatsAppsReducer = (state, action) => {
  if (action.type === "LOAD_WHATSAPPS") {
    const mItens = (action.payload || []).map(normalizarWhatsAppItem)
    return [...mItens]
  }

  if (action.type === "UPDATE_WHATSAPPS") {
    const oWhatsApp = normalizarWhatsAppItem(action.payload)
    const nIndice = state.findIndex((s) => s.canalId === oWhatsApp.canalId)

    if (nIndice !== -1) {
      const mNovo = [...state]
      mNovo[nIndice] = oWhatsApp
      return mNovo
    }
    return [oWhatsApp, ...state]
  }

  if (action.type === "UPDATE_SESSION") {
    const oSessao = action.payload
    const nCanalId = oSessao?.canalId ?? oSessao?.id
    const nIndice = state.findIndex((s) => s.canalId === nCanalId)

    if (nIndice === -1) {
      logCanalAusenteNoEstado("UPDATE_SESSION", nCanalId)
      return [...state]
    }

    const mNovo = [...state]
    const oAtual = mNovo[nIndice]
    mNovo[nIndice] = {
      ...oAtual,
      status: normalizarStatusConexao(oSessao.status ?? oAtual.status),
      updatedAt: oSessao.updatedAt ?? oAtual.updatedAt,
      qrcode: oSessao.qrcode !== undefined ? oSessao.qrcode : oAtual.qrcode,
      retries: oSessao.retries !== undefined ? oSessao.retries : oAtual.retries,
      socketAlive: oSessao.socketAlive !== undefined ? oSessao.socketAlive : oAtual.socketAlive,
      dataUltimaVisualizacao:
        oSessao.dataUltimaVisualizacao !== undefined
          ? oSessao.dataUltimaVisualizacao
          : oAtual.dataUltimaVisualizacao,
      workerId: oSessao.workerId !== undefined ? oSessao.workerId : oAtual.workerId,
      desconexaoPendente:
        oSessao.desconexaoPendente !== undefined ? oSessao.desconexaoPendente : oAtual.desconexaoPendente,
      agendaImportacaoStatus:
        oSessao.agendaImportacaoStatus !== undefined
          ? oSessao.agendaImportacaoStatus
          : oAtual.agendaImportacaoStatus,
      agendaImportacaoErro:
        oSessao.agendaImportacaoErro !== undefined
          ? oSessao.agendaImportacaoErro
          : oAtual.agendaImportacaoErro,
      agendaImportadaEm:
        oSessao.agendaImportadaEm !== undefined ? oSessao.agendaImportadaEm : oAtual.agendaImportadaEm,
      agendaImportacaoIniciadaEm:
        oSessao.agendaImportacaoIniciadaEm !== undefined
          ? oSessao.agendaImportacaoIniciadaEm
          : oAtual.agendaImportacaoIniciadaEm,
      agendaImportacaoExpiraEm:
        oSessao.agendaImportacaoExpiraEm !== undefined
          ? oSessao.agendaImportacaoExpiraEm
          : oAtual.agendaImportacaoExpiraEm,
      agendaImportacaoRetentativaAutomatica:
        oSessao.agendaImportacaoRetentativaAutomatica !== undefined
          ? oSessao.agendaImportacaoRetentativaAutomatica
          : oAtual.agendaImportacaoRetentativaAutomatica,
      agendaImportacaoTentativaId:
        oSessao.agendaImportacaoTentativaId !== undefined
          ? oSessao.agendaImportacaoTentativaId
          : oAtual.agendaImportacaoTentativaId,
    }
    return mNovo
  }

  if (action.type === "COMANDO_FALHOU") {
    const { conexaoId } = action.payload
    const nIndice = state.findIndex((s) => s.canalId === conexaoId)
    const mNovo = [...state]

    if (nIndice !== -1) {
      const oAtual = mNovo[nIndice]
      const cStatus = statusComandoFalhouResolver(action.payload, oAtual)
      mNovo[nIndice] = {
        ...oAtual,
        desconexaoPendente: false,
        ...(cStatus
          ? {
              status: cStatus,
              ...(cStatus === "DISCONNECTED"
                ? { socketAlive: false, qrcode: "" }
                : {}),
            }
          : {}),
      }
    } else {
      logCanalAusenteNoEstado("COMANDO_FALHOU", conexaoId)
    }

    return mNovo
  }

  if (action.type === "OPTIMISTIC_DISCONNECT") {
    const nCanalId = action.payload
    const nIndice = state.findIndex((s) => s.canalId === nCanalId)
    if (nIndice === -1) {
      logCanalAusenteNoEstado("OPTIMISTIC_DISCONNECT", nCanalId)
      return [...state]
    }
    const mNovo = [...state]
    mNovo[nIndice] = {
      ...mNovo[nIndice],
      status: "DISCONNECTED",
      socketAlive: false,
      qrcode: "",
      desconexaoPendente: true,
    }
    return mNovo
  }

  if (action.type === "CLEAR_DISCONNECT_PENDING") {
    const nCanalId = action.payload
    const nIndice = state.findIndex((s) => s.canalId === nCanalId)
    if (nIndice === -1) {
      return [...state]
    }
    const mNovo = [...state]
    mNovo[nIndice] = { ...mNovo[nIndice], desconexaoPendente: false }
    return mNovo
  }

  if (action.type === "DELETE_WHATSAPPS") {
    const nCanalId = action.payload
    return state.filter((s) => s.canalId !== nCanalId)
  }

  if (action.type === "RESET") {
    return []
  }

  return state
}
